import React from "react"

import Publication from "./Publication"
import EmptyMessage from "./EmptyMessage"

const PublicationsList = (props) => {
  
  const { publications, includeMeta, onTagClick } = props
  const count = publications.length
  const activeTags = []

  if (count === 0) {
    return (
      <EmptyMessage
        title="That’s an interesting combo!"
        subtitle="Maybe we should collaborate on a proposal. :)"
        body="But in the meantime, please try a less specific combination!"
      />
    )
  } 

  return (
    <ul className="is-unstyled">
      {publications && publications.map( (publication, index) => {
        let node = publication
        if (publication.node !== undefined) {
          node = publication.node
        }

        return (
          <Publication 
            position={count - index}
            key={node.id} 
            includeMeta={includeMeta}
            publication={node} 
            onTagClick={onTagClick}
            activeTags={activeTags}
          />
        )
      }
      )}
    </ul>
  )
}

export default PublicationsList